export class UserSessionService {
    /* @ngInject */
    constructor($http, $resource, egUrlService, $log, $q) {
        this.egUrlService = egUrlService;
        this.$http = $http;
        this.$log = $log;
        this.$q = $q;
        var url = this.egUrlService.url('/authentication/userSessions');
        this.sessionWebService = $resource(url, null, {
            userSessions: {
                method: 'GET',
                isArray: true
            },
            userSession: {
                url: this.egUrlService.url('/authentication/userSessions/current'),
                method: 'GET'
            }
        });
    }

    getUserSession() {
        return this.sessionWebService.userSession().$promise;
    }

    getUserSessions() {
        return this.sessionWebService.userSessions().$promise;
    }

    logout(sessionId) {
        var url = this.egUrlService.url('/authentication/userSessions/logout?sessionId={{sessionId}}', {
            sessionId: sessionId
        });

        return this.$http.post(url)
            .then(response => { this._requestSuccess(response); }, response => { this._requestError(response); });
    }

    _requestSuccess(response) {
        return response;
    }

    _requestError(response) {
        return this.$q.reject(response.data);
    }
}